<template>
  <div class="imanage-list-container">
    <TagsCloud ref="cloudtage" @cloudTages="cloudTages" />

    <div class="manage-table">
      <avue-crud
        :option="tableConfig"
        :data="tableData"
        v-model="searchForm"
        :page.sync="page"
        :search.sync="searchForm"
        :summary-method="summaryMethod"
        @search-reset="searchReset"
        @on-load="queryTableData"
        @search-change="searchChange"
        @sort-change="sortChange"
        @refresh-change="queryTableData"
        @selection-change="selectionChange"
      >
        <template slot="searchMenu" slot-scope="{ row }">
          <el-button type="primary" @click="saveData(row)">保存</el-button>
          <!-- <el-button type="primary" @click="openFilter">
            <a-icon type="filter" /> 高级筛选
          </el-button> -->
        </template>

        <template slot="menuLeft">
          <el-button
            size="small"
            type="primary"
            icon="el-icon-plus"
            @click="handleAdd()"
            v-if="permission.InvestLoanManage_add"
          >
            新增投放
          </el-button>
          <el-button
            size="small"
            type="primary"
            icon="el-icon-edit"
            plain
            @click="handleEdit()"
            v-if="permission.InvestLoanManage_edit"
          >
            编辑
          </el-button>
          <el-button
            type="danger"
            size="small"
            icon="el-icon-delete"
            plain
            @click.stop="handleDelete()"
            v-if="permission.InvestLoanManage_delete"
            >删除
          </el-button>          
          <el-button size="small" icon="el-icon-download" @click="exportShow"
            >导出数据
          </el-button>
        </template>

        <template slot="sellerCustNameSearch">
          <CommonSelect
            bindLabel="dictValue"
            bindKey="dictKey"
            bindValue="dictValue"
            dataUrl="/blade-/zd/custom/dict"
            @handleChange="setSellerCustId"
          />
        </template>
        <template slot="investName" slot-scope="{ row }">
          <div class="project-name" @click="goDetail(row)">
            {{ row.projectName }}
          </div>
        </template>
        <template slot="contractTitle" slot-scope="{ row }">
          <div class="project-name">{{ row.contractManage.projectName }}</div>
        </template>
        <template slot="contractAmount" slot-scope="{ row }">
          <div class="project-name">
            {{ getMoney(Number(row.contractManage.factoringCredit)) }}元
          </div>
        </template>
        <template slot="quotaStatus" slot-scope="{ row }">
          <div class="quota-status" v-if="row.status == 1">生效</div>
          <div class="quota-status red-point" v-else>失效</div>
        </template>
      </avue-crud>
    </div>

    <ExportData ref="exportData" @exportDownload="exportDownload" />
  </div>
</template>
<script>
import { queryInvestLoanList, removeInvestLoan } from "@/api/factoring/factoring";
import { downLoadTemplate } from "@/router/downLoadTem";
import TagsCloud from "@/components/TagsCloud/TagsCloud";
import ExportData from "@/components/exportData/exportData";
import SelectPerson from "@/components/SelectPersonnel/person";
import SelectDepartment from "@/components/SelectDepartment/department";
import { tableConfig, filterConfig } from "./ILManageConfig.js";
import commonList from "@/mixins/list";
import { mapGetters } from "vuex";
import workFlow from '@/mixins/workFlow'
import { floatAdd } from "@/util/util";
import moment from "moment"
export default {
  name: "InvestLoanManagement",
  mixins: [workFlow],
  data() {
    return {
      files: [],
      tableData: [],
      selectionList: [],
      tableConfig: tableConfig(this.getMoney),
      filterConfig: filterConfig(),
      page: {
        currentPage: 1,
        total: 0,
        layout: "total,pager,prev, next",
        background: false,
        pageSize: 10,
      },
      searchForm:{

      }
    };
  },
  components: {
    TagsCloud,
    SelectPerson,
    SelectDepartment,
    ExportData,
  },
  computed: {
    ...mapGetters(["userInfo",'permission']),
  },
  mounted() {},
  methods: {
    summaryMethod({ columns, data }) {
      const sums = [];
      if (columns.length > 0) {
        columns.forEach((column, index) => {
          if ([6, 7, 8, 9, 11].includes(index)) {
            let values = 0;
            data.map(
              (item) =>
                
                (values =floatAdd(values,Number(item[column.property])))
            );
            // console.log(values);
            sums[index] = `${this.getMoney(values.toFixed(2))}元`;
          } else {
            sums[index] = "-";
          }
        });
      }
      return sums;
    },

    cloudTages(data) {
      this.searchForm = data;
    },

    saveData(row) {
      this.$refs.cloudtage.save(row);
    },
    selectionChange(list) {
      this.selectionList = list;
    },

    searchReset() {
      this.searchForm = {};
      this.queryTableData();
    },

    handleAdd() {
      this.$router.push({
        path: "/factoring/InvestmentLoanManagement/addInvestmentLoan",
      });
    },

    async handleEdit() {
      let self=this
      if (this.selectionList.length > 1) {
        this.$message.error("只能选择一条数据进行编辑");
      } else if (this.selectionList.length == 1) {
        let data = this.selectionList[0];
        if (this.userInfo.nick_name != data.managerUserName) {
          this.$message.warning("非创建者无权限编辑本条数据");
        } else {
          let processDetail= await self.queryTaskDetail(data.flowableId)
          let flowData=processDetail.flowData
          let presentFlow = flowData[flowData.length - 1]
          if (data.auditStatus == 0||(presentFlow.historyActivityId ==
            flowData[0].historyActivityId)) {
            this.$router.push({
              path: `/factoring/InvestmentLoanManagement/editInvestmentLoan/${data.id}`,
            });
          } else {
            this.$message.warning("该条数据已提交流程");
          }
        }
      } else {
        this.$message.error("请选择一条数据进行编辑");
      }
    },

    async handleDelete() {
      let self = this
      let startDelete = () => {
        self.$confirm('确定删除选择的数据?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          self.deleteData()
        }).catch(() => {
          self.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      }
      if(this.selectionList.length > 1){
        this.$message.error('只能选择一条数据进行删除')
      } else if(this.selectionList.length == 1){
        if(this.selectionList[0].managerUser == this.userInfo.user_id || this.selectionList[0].assistUser == this.userInfo.user_id){
          let data = this.selectionList[0]
          if(data.flowableId != '' && data.auditStatus == 1) {
            // 获取流程数据
            await this.queryFlowData(data.flowableId)
            let presentFlow = this.flowData[this.flowData.length - 1]
            if(this.processDetail.flow[2].historyActivityId == presentFlow.historyActivityId) {
              startDelete()
            }else {
              this.$message.error('流程审批中不能删除')
            }
          }else {
            // 直接弹框提示
            startDelete()
          }
        } else {
          this.$message.error('您没有权限删除此条数据')
        }
      }else{
        this.$message.error('请选择数据进行删除')
      }
    },

    // 删除参数ids 提取this.selectionList中的id用,隔开成字符串
    async deleteData() {
      let ids = this.selectionList.map((item) => {
        return item.id
      })
      let res = await removeInvestLoan({ids: ids.join(',')})
      if(res.data.code == 200){
        this.$message.success('删除成功')
        // 刷新列表
        this.queryTableData()
      }
    },    

    searchChange(str, done) {
      this.queryTableData();
      done();
    },

    async queryTableData() {
      let params = {
        current: this.page.currentPage,
        size: this.page.pageSize,
        ...this.searchForm,
        createDateBegin: this.searchForm.timePic&&this.searchForm.timePic.length>0
          ? moment(this.searchForm.timePic[0]).format("YYYY-MM-DD")
          : undefined,
        createDateEnd: this.searchForm.timePic&&this.searchForm.timePic.length>0
          ? moment(this.searchForm.timePic[1]).format("YYYY-MM-DD")
          : undefined,
        
      };
      let res = await queryInvestLoanList(params);
      if (res.data.code == 200) {
        this.tableData = res.data.data.records;
        this.page.total = res.data.data.total;
        this.dealList(this.tableData);
      } else {
        this.$message.error(res.data.msg);
      }
    },

    dealList(data) {
      data.map((item) => {
        item.projectName = item.contractManage.projectName;
        item.projectTypeStr = item.contractManage.projectTypeStr;
        item.sellerCustName = item.contractManage.sellerCustName;
        item.contractName = item.contractManage.contractName;
        item.factoringCredit = item.contractManage.factoringCredit;
        item.xirrStr = `${(Number(item.contractManage.xirr) * 100).toFixed(
          4
        )}%`;
      });
    },

    goDetail(row) {
      if(!this.permission.InvestLoanManage_view){
        this.$message.error("没有查看权限");
        return
      }
      this.$router.push({
        path: `/factoring/InvestmentLoanManagement/investmentLoanDetail/${row.id}`,
      });
    },
    
    exportShow() {
      this.$refs.exportData.showModel();
    },

    exportDownload(value) {
        let page = this.page;
        let data = {
            export: value.code,
            auditState: 1
        };
        if (value.code == 1) {
            data = {
                ...data,
                firstNum: (page.currentPage - 1) * page.pageSize,
                num: page.pageSize,
                ...this.searchForm,
            };
        } else if (value.code == 2) {
            data = {
                ...data,
                ...this.searchForm,
            };
        }
        downLoadTemplate("/api/bl/blinvest/export", data).finally(() => {
            this.loading = false;
            this.$message({
            type: "success",
            message: "已下载",
            });
        });
    }
  },
};
</script>
<style lang="scss" scoped>
.imanage-list-container {
  /deep/.el-table .cell  {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
  .topcrud {
    line-height: 45px;
    font-size: 18px;
    background: #f9f9f9;
    border-radius: 15px 15px 0 0;
    text-indent: 25px;
    // margin: 0 5px;
    border-bottom: 1px solid #e9e9e9;
    .messagetitle {
      font-weight: bolder;
    }
  }
  .manage-table {
    background: #ffff;
    padding: 25px;
  }
  .project-name{
    // overflow: hidden;
    white-space: normal;
    // text-overflow: ellipsis;
    color: #409EFF;
  }
  .project-name:hover {
    color: #409eff;
    cursor: pointer;
  }
}
</style>
<style lang="scss">
.imanage-list-container {
  .el-table__fixed,
  .el-table__fixed-right {
    height: calc(100% - 51px) !important;
  }
  .el-table__fixed-footer-wrapper {
    display: none !important;
  }
}
</style>